exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 767px){\n.mobile-view-margin[data-v-d2d0a79e]{\n  margin-top: -22px;\n}\n}\n\n", ""]);

// exports
